import * as Sentry from '@sentry/react'

export function createNumFormatterWithFallback(
  language: string,
  options: Intl.NumberFormatOptions
) {
  try {
    return new Intl.NumberFormat(language, options).format
  } catch (err: unknown) {
    Sentry.captureException(err, {
      level: 'error',
      extra: {
        language,
        maximumFractionDigits: options.maximumFractionDigits,
        minimumFractionDigits: options.minimumFractionDigits,
        style: options.style,
        currency: options.currency
      },
      tags: {
        function: 'createNumFormatterWithFallback'
      }
    })
    return (number: number) => number.toFixed(options.maximumFractionDigits)
  }
}

export const createEuroCurrencyFormatterWithFallback = (
  language: string,
  options: Intl.NumberFormatOptions
) => {
  try {
    return new Intl.NumberFormat(language, {
      style: 'currency',
      currency: 'EUR',
      ...options
    }).format
  } catch (err: unknown) {
    Sentry.captureException(err, {
      level: 'error',
      extra: {
        maximumFractionDigits: options.maximumFractionDigits,
        minimumFractionDigits: options.minimumFractionDigits
      },
      tags: {
        function: 'createEuroCurrencyFormatterWithFallback'
      }
    })

    return (number: number) => number.toFixed(options.maximumFractionDigits)
  }
}
